import { CookiesEvents } from './PluginCookies.ts'
/**
 * Blocks embeds
 */
const blockEmbeds = () => {
  /**
   * Check if domains var exist
   */
  const EMBED_DOMAINS_TO_BLOCK = ['youtube.com', 'facebook.com']

  if (EMBED_DOMAINS_TO_BLOCK) {
    // if (EMBED_DOMAINS_TO_BLOCK.includes('youtube.com')) {
    // 	document.querySelectorAll('[data-video="yt"]').forEach((item) => {
    // 		item.removeAttribute('data-video');
    // 	});
    // }

    //   Get all iframes and embeds
    document
      .querySelectorAll<HTMLScriptElement>('iframe, embed')
      .forEach((embed) => {
        let shouldBeBlocked = false
        // If src includes one of domains set shouldBeBlocked as true
        EMBED_DOMAINS_TO_BLOCK.forEach((domain) => {
          const pattern = new RegExp('\\b' + domain + '\\b')

          if (pattern.test(embed.src)) {
            shouldBeBlocked = true
          }
        })

        //   If should be blocked change src to cookies info page
        if (shouldBeBlocked) {
          embed.src = ''
          for (const [key, value] of Object.entries(embed.dataset)) {
            console.log(`${key}: ${value}`)
          }
        }
      })
  }
}

const listen = () => {
  if (window.CookiesController) {
    if (window.CookiesController.isCookieAccepted('bw-cookie-socials')) {
      blockEmbeds()
      window.removeEventListener(CookiesEvents.ACTION, listen)
    }
  }
}

/**
 *  Block embeds on bw-cookies-action event if Socials cookies are not accepted
 */
window.addEventListener(CookiesEvents.ACTION, listen)
